<template>
  <router-link :to="{ name: 'course.view', params: { id: course.id } }" class="course-card" active-class="active">
    <div class="course-card__head" :style="coursePreview">
      <div class="course-card__header-wrapper">
        <div class="course-card__header">
          {{ course.title }}
        </div>
      </div>
    </div>
    <div class="course-card__body">
      <div v-if="completed" class="course-card__status course-card__status-completed">
        <div class="course-card__icon course-card__icon-completed"><fa icon="check" fixed-width /></div>
        <label class="course-card__label course-card__label-completed">{{ $t('course_completed') }}</label>
        <div class="course-card__stars stars_block">
          <span class="stars_block__item" :class="{ 'stars_block__item-success': result > 0 }"><fa icon="star" fixed-width /></span>
          <span class="stars_block__item" :class="{ 'stars_block__item-success': result >= 0.34 }"><fa icon="star" fixed-width /></span>
          <span class="stars_block__item" :class="{ 'stars_block__item-success': result >= 0.67 }"><fa icon="star" fixed-width /></span>
        </div>
      </div>
      <div v-if="!completed" class="course-card__status course-card__status-uncompleted">
        <div class="course-card__icon course-card__icon-uncompleted" title="Не пройден">
          <fa icon="question" fixed-width />
        </div>

        <label class="course-card__label course-card__label-uncompleted">Не пройден</label>

        <div class="course-card__study">Пройти первое занятие</div>
      </div>
    </div>
  </router-link>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: "CourseCard",
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      userCourse: function () {
        console.log('course: ', this.course);
        if (this.user && this.course) {
          const userCourse = this.user.user_courses.find(el => el.course_id === this.course.id);
          if (userCourse) {
            const userLessons = this.user.user_lessons.filter(ul => ul.course_id === userCourse.course_id);
            const lessonResults = this.course.lessons.map(l => 0);
            userLessons.forEach((ul, i) => {
              lessonResults[i] = ul.result
            });
            userCourse.result = (lessonResults.reduce((a, b) => (a + b), 0) / lessonResults.length) || 0;
            userCourse.completed = lessonResults.filter(l => (l === 0)).length === 0;
            return userCourse;
          }
        }
        return false;
      },
      studying: function () {
        console.log(this.userCourse);
        return !!this.userCourse;
      },
      result: function () {
        return this.userCourse ? this.userCourse.result : 0;
      },
      completed: function () {
        return this.userCourse ? this.userCourse.completed : false;
      },
    },
    data: () => ({
      coursePreview: ''
    }),
    props: {
      course: {
        type: Object,
      },
    },
    mounted () {
      console.log(this.user);
      if (this.course.preview) {
        this.coursePreview = 'background-image: url(/images/courses/' + this.course.id + '/' + this.course.preview + ')'
      }
    },
    methods: {
    }
  }
</script>
